import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { DataCheckupResponse, EmailResult, PhoneResult, AddressResult } from '../../../services/ph3aService';

interface CheckupResultDisplayProps {
  data: DataCheckupResponse;
}

// exibindo o valor de forma destacada
const ValueBadge: React.FC<{ value: number }> = ({ value }) => {
    const badgeClass = value > 75 ? 'bg-success' : value > 50 ? 'bg-warning' : 'bg-danger';
    return <span className={`badge ${badgeClass}`}>{value}%</span>;
};

const CheckupResultDisplay: React.FC<CheckupResultDisplayProps> = ({ data }) => {
  const checkupData = data.Data;

  if (data.Error) {
      return <div className="alert alert-danger mt-3"><strong>Erro na consulta:</strong> {data.Error}</div>;
  }
  if (!checkupData) {
    return <div className="alert alert-warning mt-3">Nenhum dado retornado no checkup.</div>;
  }
  
  const formatAddress = (addr: AddressResult) => {
    if (addr.Alias) {
      return `Alias: ${addr.Alias} (CEP: ${addr.ZipCode})`;
    }
    const parts = [addr.Street, addr.Number, addr.City, addr.State].filter(Boolean);
    return parts.join(', ');
  };

  return (
    <div className="mt-4">
      <h5 className="mb-3">Resultados do Checkup</h5>
      {/* SEÇÃO DE EMAILS */}
      {checkupData.Email?.length > 0 && (
        <div className="mb-3">
          <h6>Emails</h6>
          <table className="table table-sm table-bordered">
            <thead><tr><th>Email</th><th style={{width: '120px'}}>Confiança</th></tr></thead>
            <tbody>
              {checkupData.Email.map((item, index) => (
                <tr key={`email-${index}`}><td>{item.Email}</td><td><ValueBadge value={item.Value} /></td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* SEÇÃO DE TELEFONES */}
      {checkupData.Phone?.length > 0 && (
        <div className="mb-3">
          <h6>Telefones</h6>
          <table className="table table-sm table-bordered">
            <thead><tr><th>Telefone</th><th style={{width: '120px'}}>Confiança</th></tr></thead>
            <tbody>
              {checkupData.Phone.map((item, index) => (
                <tr key={`phone-${index}`}><td>{`(${item.Area}) ${item.Number}`}</td><td><ValueBadge value={item.Value} /></td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* SEÇÃO DE ENDEREÇOS */}
      {checkupData.Address?.length > 0 && (
        <div>
          <h6>Endereços</h6>
          <table className="table table-sm table-bordered">
            <thead><tr><th>Endereço</th><th style={{width: '120px'}}>Confiança</th></tr></thead>
            <tbody>
              {checkupData.Address.map((item, index) => (
                <tr key={`addr-${index}`}><td>{formatAddress(item)}</td><td><ValueBadge value={item.Value} /></td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CheckupResultDisplay;